<template>
    <section class="chart-container">
          <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="统计维度" >
					<el-select v-model="dimension" placeholder="请选择统计维度"  style="width:100px"   @change="getDataList" >
						<el-option label="项目" value="project"></el-option>
						<el-option label="点位" value="device"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="项目">
					<el-select v-model="filters.projectId" multiple  collapse-tags  style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
                <el-form-item label="功能区" >
					<el-select v-model="filters.functionalArea"  reserve-keyword>
                        <el-option label="全部" value=""></el-option>
						<el-option
							v-for="item in functionalAreaList"
							:label="item.name"
							:value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="因子"  >
					<el-select v-model="filters.facKeyword"   style="width:100px"  >
                        <el-option
							v-for="item in factors"
							:label="item.name"
							:value="item.key" :key="item.key">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="数据类型">
					<el-select v-model="filters.datatype"  @change="changeType"   style="width:100px" >
						<!-- <el-option label="小时" value="hour"></el-option> -->
						<el-option label="天" value="day"></el-option>
                        <el-option label="月" value="month"></el-option>
                        <el-option label="季度" value="quarter"></el-option>
                        <el-option label="年" value="year"></el-option>
					</el-select>
				</el-form-item>
             	<el-form-item label="时间">
					<el-date-picker  v-model="filters.time" :type="timeType"  value-format="yyyy-MM-dd HH:mm:ss">  </el-date-picker>
                </el-form-item>
                <el-form-item  v-if="filters.datatype=='quarter'">
                    <el-select v-model="filters.quarter"    style="width:100px"  reserve-keyword>
                        <el-option value="1" label="第一季度"></el-option>
                        <el-option value="2" label="第二季度"></el-option>
                        <el-option value="3" label="第三季度"></el-option>
                        <el-option value="4" label="第四季度"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item>
                    <my-button  @select-type="clickBtn" QueryButtonShow ResetButtonShow ExportButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

       <el-table :data="dataList"  highlight-current-row v-loading="listLoading" border :height="formHeight">
           	<el-table-column type="index" label="排名" width="60"  > </el-table-column>
			<el-table-column  label="项目名称"   min-width="120" prop="projectName" > </el-table-column>
            <el-table-column  label="功能区名称"   min-width="120" prop="functionalAreaName"   v-if="dimension=='device'"></el-table-column>
			<el-table-column label="点位名称"   min-width="120" prop="deviceName"     v-if="dimension=='device'"></el-table-column>
            <el-table-column :prop="chooseFac" label="数值（dB）"  min-width="120" sortable></el-table-column>
		</el-table>
        
    </section>
</template>

<script>
    import {getProjects,selectNoiseDataForRank,getFunctionalAreaList} from '../../api/api';
    import {formatDate} from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

	export default {
        components: { myButton },
        data() {
            return {
                filters: {
                    facKeyword:'n00001',
                    projectId:[],
                    time:"",
                    datatype:"day",
                    functionalArea:"",
                    quarter:"1"
                },
                dimension:"device",
                projects:[],
                factors:[],
                hourfactors:[
                    { name:"等效声级",key:"n00001" }
                ],
                dayfactors:[
                    {  name:"等效声级",key:"n00001" },
                    {  name:"昼数据",key:"n00004" },
                    {  name:"夜数据",key:"n00005" },
                ],
                dataList:[],
                listLoading:false,
                formHeight:0,

                functionalAreaList:[],
                timeType:"date",
                chooseFac:"",
                chooseDimension:""
            }
        },
        methods: {
            changeType(){
                if(this.filters.datatype=="hour"){
                    this.timeType="datetime";
                    // this.factors=this.hourfactors;
                }else if(this.filters.datatype=="day"){
                    this.timeType="date";
                    // this.factors=this.dayfactors;
                }else if(this.filters.datatype=="month"){
                    this.timeType="month";
                    // this.factors=this.dayfactors;
                }else if(this.filters.datatype=="year"){
                    this.timeType="year";
                    // this.factors=this.dayfactors;
                }else if(this.filters.datatype=="quarter"){
                    this.timeType="year";
                    // this.factors=this.dayfactors;
                }
            },
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="reset"){
					this.reset();
				}else if(type=="export"){
					this.exportData();
				}
			},
            reset(){
                this.filters.projectId=[];
                this.filters.functionalArea="";
                this.filters.dataType="day";
                this.timeType="date";
                var data=new Date();
                data.setSeconds(0);
                data.setMinutes(0);
                data.setHours(6);
                data.setTime(data.setDate(data.getDate()-1));
                this.filters.time=formatDate(data);
                this.factors=this.dayfactors;
            },
            exportData(){
                require.ensure([], () => {
                    const { export_json_to_excel } = require('vendor/Export2Excel');
                    var tHeader =  [];
                    var filterVal = [];  
                    if(this.chooseDimension=="device"){
                        tHeader =  [ '排名','项目名称','功能区名称', '点位名称', '数值（dB）' ];
                        filterVal = ['index','projectName', 'functionalAreaName', 'deviceName',this.chooseFac ];  
                    }else{
                        tHeader =  [ '排名','项目名称', '数值（dB）' ];
                        filterVal = ['index','projectName' ,this.chooseFac ];  
                    }

                    var data=[];
                    var sheetName=[];
                    data.push(this.formatJson(filterVal, this.dataList));
                    sheetName.push('Sheet1');

                    export_json_to_excel(tHeader, data, '数值排名数据',sheetName);
                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
            //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                   this.projects = res.data.data;
                    this.listLoading = false;
                    
			        if(this.projects.length>0){
                        this.filters.projectId=[];
                        this.filters.projectId.push(this.projects[0].projectId);
						this.getDataList();

					}
				});
			},
            getFunctionalAreaList(){
                getFunctionalAreaList({}).then((res) => {
                    this.functionalAreaList=res.data.data;
				});
			},
            //获取趋势分析数据
            getDataList(){
                if(this.filters.projectId.toString()==""){
                    this.$message({
						message: "项目不能为空",
						type: 'error'
					})
					return;
                } 
                let para = {
                    projectIdStr:this.filters.projectId.toString(),
                    functionalAreaId:this.filters.functionalArea,
                    dataType:this.filters.datatype,
                    dimension:this.dimension,
                    factory: this.filters.facKeyword,
                    time:  this.filters.time,
                    quarter:this.filters.quarter
                };

                //如果是季度和年的话，time处理
                if(para.dataType=="year"||para.dataType=="quarter"){
                    para.time=para.time.split("-")[0];
                }
                this.listLoading = true;
                
				selectNoiseDataForRank(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result=="true"){
                        this.chooseFac=this.filters.facKeyword;
                        this.chooseDimension=this.dimension;
                        this.dataList = res.data.datas;
                        for(var i=0;i<this.dataList.length;i++){
                            this.dataList[i].index=(i+1);
                        }
                    } else{
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
                    }
				});
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
        },
        mounted: function () {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
            },10)

            var data=new Date();
            data.setSeconds(0);
            data.setMinutes(0);
            data.setHours(6);
            data.setTime(data.setDate(data.getDate()-1));
            this.filters.time=formatDate(data);

            this.factors=this.dayfactors;

            this.getProjects();
            this.getFunctionalAreaList();
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// OrderNumQuery.vue?5f11e480